/**********************************************************
Fab button Modal: Button actions for view, edit and deleting
**********************************************************/
import CultivationModal from './cult_modal';
import { filterOldRecords } from '../cult_utils';
import React from 'react';

// It's Fabulous!
const FabModalV2 = (WrappedComponent) => (props) => {
  let { user, application, _select, auth } = props;
  if (auth) {
    return (
      <div>
        { Object.keys(user).length === 0 ? ''
          : user.level >= 3 || user.positionTitle.match(/Cultivation/) ?
            <div>
              <li className="action-btn-li">
                <a className={`btn-floating red pointer modal-trigger tooltipped btn-squared ${filterOldRecords(application) ? '' : 'disabled'}`} href={`#${application.id}-delete`}
                  data-position="top" data-tooltip="Delete" onClick={() => _select(application)}>
                  <i className="material-icons">clear</i>
                </a>
              </li>
              { CultivationModal(WrappedComponent)({ ...props }) }
            </div>
          : ''
        }
      </div>
    )
  }
  return (
    <div>
      <li className="action-btn-li">
        <a className="btn-floating green pointer modal-trigger tooltipped btn-squared" href={`#${application.id}-view`}
          onClick={() => _select(application)}  data-position="left" data-tooltip="View">
          <i className="material-icons">subject</i>
        </a>
      </li>
      { CultivationModal(WrappedComponent)({ ...props }) }
    </div>
  );
}

export default FabModalV2;




/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/fab_modal_v2.js